
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { preloadCriticalImages } from './utils/preloadImages';

import Home from './pages/Home'
import SingleProduct from './pages/SingleProduct'

import Header from './components/Header';
import Footer from './components/Footer';
import BannerBar from './components/BannerBar';
import ImageCacheManager from './components/ImageCacheManager';

import { useProductContext } from './context/ProductContext';
import LoadingBar from './components/LoadingBar';


function App() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScrollY(window.scrollY);
    });
    
    // Preload critical images
    preloadCriticalImages().then(() => {
      console.log('Critical images preloaded');
    }).catch((error) => {
      console.warn('Failed to preload some images:', error);
    });
  }, []);

  const { isLoading } = useProductContext();
  if(isLoading){
    return (
      <>
      <LoadingBar />
      </>
  )
  }
  return (
 <div className='w-screen  transition-all ease-linear duration-300 bg-gray-100'>
 <Helmet>
  <title>AST Earbuds | Best Wireless Earbuds & Audio Accessories</title>
  <meta name="description" content="AST offers the best wireless earbuds, fast chargers, and audio accessories. Discover high-quality sound, advanced features, and affordable prices. Shop AST for your next audio upgrade!" />
 </Helmet>
<Router
  future={{
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }}
>
  <BannerBar />
  <Header />
  <Routes>
  <Route path="/" element={<Home />}/>
  <Route path="/sample-page#store" element={<Home />}/>
    <Route path="/shop#store" element={<Home />}/>
  <Route path="/store#store" element={<Home />}/>
  <Route path="/products#store" element={<Home />}/>
    <Route path="/product/:id" element={<SingleProduct />}/>
    <Route path="/*" element={<Home />}/>
  </Routes>
    <Footer/>
   {scrollY > 100 && <button
   aria-label='scroll-to-top'
     id='scroll-to-top'
     className='fixed bottom-4 right-4 z-50 w-8 h-8 bg-primary hover:bg-primary/80 text-white p-1 rounded-full shadow-lg transition-colors'
     onClick={() => {
      setScrollY(0);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }}>
      <i className="fa-solid fa-arrow-up text-sm"></i>
    </button>}
   {
    process.env.NODE_ENV === 'development' && <ImageCacheManager />
   }
    
</Router>
 </div>

  );
}

export default App;
